<template>
  <div id="personal">
    <div class="personal-content">
      <div class="personal-banner">
        <img src="../../../static/images/personal-banner.jpg" alt="">
      </div>

      <div class="personal-main">

        <div class="personal-detail clearfix">
          
          <div class="personal-icon">
            <img src="../../../static/images/personal-icon1.png" alt="">
          </div>

          <div class="personal-kh" v-html="personal_kh"></div>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavDom from '@/components/navtop/navloginbefore'
export default {
  name: 'Personal',
  data() {
    return {
      personal_kh:"虽然你现在只有一个人，现在你可以永久免费代理平台 <br/>业务，可以发展团队，扩展你的队伍，开启代理致富之路。"
    }
  },
  created () {
    /*this.getConpy();*/
  },
  methods: {
    
  },
  components: {
    NavDom
  }
}
</script>

<style lang="stylus" scoped>
  .personal-banner
    img
      width 100%

  .personal-main
    width 1080px
    margin 0 auto

    .personal-detail
      padding 50px 0

      .personal-icon
        float left
        margin 0 35px 0 0
        width 245px

        img
          width 100%

      .personal-kh
        float left
        font-size 30px
        color #000000
        text-align center
        line-height 60px
        width 800px
        margin 100px 0 0 0

    
</style>


// WEBPACK FOOTER //
// src/components/service/personal.vue